// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"166b73fd","453":"8456913f","455":"6e2f62ac","679":"045936cb","977":"8be92831"}[chunkId] + ".chunk.js";
};